import { Flex, FlexProps, Spinner, Text } from "@chakra-ui/react";
import { useIsSmallBreakpoint } from "../../../utils/useBreakpoints";
import { ChatMessage } from "./ChatMessage";
import { useChatContext } from "../hooks/useChat";
import { useRef, useState } from "react";

export function ChatLog({
  compact,
  ...containerProps
}: { compact?: boolean } & FlexProps) {
  const isSmallScreen = useIsSmallBreakpoint();

  const {
    isLoaded,
    messageArray: messages,
    members,
    roomStatus,
    handleToggleReaction,
    handleDeleteMessage,
  } = useChatContext();

  const [fullyScrolled, setFullyScrolled] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const el = containerRef.current;
    if (!el) return;

    const containerHeight = el.scrollHeight - el.clientHeight - 1;
    const isFullyScrolled = Math.abs(el.scrollTop) >= containerHeight;

    setFullyScrolled(isFullyScrolled);
  };

  const showSpinner = !(roomStatus === "attached") || !isLoaded;
  const showMessages = messages.length > 0 && !showSpinner;
  return (
    <Flex
      ref={containerRef}
      onScroll={handleScroll}
      className="styled-scrollbar-hover"
      flexGrow={1}
      width="100%"
      flexDirection="column-reverse"
      maxHeight="inherit"
      overflow="auto"
      gap="8px"
      py="8px"
      px={isSmallScreen ? "16px" : 0}
      alignItems={!showMessages ? "center" : "flex-start"}
      justifyContent={!showMessages ? "center" : "flex-start"}
      style={{
        maskImage: fullyScrolled
          ? undefined
          : "linear-gradient(to bottom, transparent, var(--chakra-colors-charcoal-charcoal) 100px)",
      }}
      transition="mask-image .2s linear"
      {...containerProps}
    >
      {!showMessages ? (
        <>
          {showSpinner ? (
            <Text color="dune.dune">Joining room...</Text>
          ) : (
            <Text textAlign="center" color="dune.dune">
              There's nothing here yet.
              <br />
              Be the first to send a message!
            </Text>
          )}
          {showSpinner ? (
            <Spinner color="blaze.blaze" emptyColor="transparent" size="xl" />
          ) : null}
        </>
      ) : (
        messages.map((message, i) => {
          if (message.isDeleted) return null;
          return (
            <ChatMessage
              compact={compact}
              message={message}
              members={members}
              deleteMessage={handleDeleteMessage}
              toggleReaction={handleToggleReaction}
              key={i}
            />
          );
        })
      )}
    </Flex>
  );
}
